import { Navigate } from 'react-router-dom';
import { readSession } from '../../utils/session';

// Check before mounting children: their render/effects can read stored user data.
export default function SessionGate({ children }) {
  return readSession() ? children : <Navigate to="/" replace />;
}
